import React from 'react';
import Typography from '@mui/material/Typography';
import { PaymentElement } from '@stripe/react-stripe-js';
import useStyles from './styles';
import { PaymentFormValues } from 'types/payments';

export interface PaymentFormCardFieldsProps {
  values: PaymentFormValues;
  errors: Partial<Record<keyof PaymentFormValues, string>>;
  touched: Partial<Record<keyof PaymentFormValues, boolean>>;
  handleInputChange: (
    fieldName: keyof PaymentFormValues,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | null,
    imperativeValue?: unknown,
  ) => void;
}

/**
 * Renders Stripe Payment Element only. Billing details (name, address, etc.) are
 * collected by Stripe inside the element. Parent flows should read billing from
 * the PaymentMethod returned by createPaymentMethod() if needed.
 */
const PaymentFormCardFields: React.FC<PaymentFormCardFieldsProps> = ({
  handleInputChange,
  values,
  errors,
  touched,
}) => {
  const { classes } = useStyles();
  const [creditInputActive, setCreditInputActive] = React.useState(false);

  const getLabelClassName = () => {
    if (touched.cardInfo && errors.cardInfo) return classes.errorText;
    if (creditInputActive) return classes.activeText;
    return classes.defaultText;
  };

  return (
    <div className={classes.textField}>
      <Typography variant="subtitle2" className={getLabelClassName()}>
        Card *
      </Typography>
      <div className={classes.cardInputContainer}>
        <PaymentElement
          id="cardInfo"
          onChange={(e) => handleInputChange('cardInfo', null, e)}
          onFocus={() => setCreditInputActive(true)}
          onBlur={() => setCreditInputActive(false)}
          options={{
            fields: {
              billingDetails: {
                address: 'auto',
              },
            },
          }}
        />
      </div>
      <Typography variant="caption" color="error">
        {touched.cardInfo && errors.cardInfo ? String(errors.cardInfo) : ''}
      </Typography>
    </div>
  );
};

export default PaymentFormCardFields;
